export const getServiceFieldsConfig = (fields: Array<{ name: string }>) => {
  const config = {
    id: false,
    uid: false,
    server: false,
    region: false,
    playerId: false,
    zoneId: false,
    uidPubg: false,
  }

  const result = {
    isUidOnlyService: false,
    isUidAndServerService: false,
    isUidAndServerAndRegionService: false,
    isIdAndZoneIdService: false,
    isIdAndServerService: false,
    isPlayerIdAndZoneIdService: false,
    isPlayerIdAndServerService: false,
    isPlayerIdOnlyService: false,
    isPubgService: false,
  }

  fields.forEach((field) => {
    config[field.name] = true
  })

  if (config.uid && config.server && config.region) {
    result.isUidAndServerAndRegionService = true
  } else if (config.uid && config.server) {
    result.isUidAndServerService = true
  } else if (config.uid) {
    result.isUidOnlyService = true
  } else if (config.id && config.zoneId) {
    result.isIdAndZoneIdService = true
  } else if (config.id && config.server) {
    result.isIdAndServerService = true
  } else if (config.playerId && config.zoneId) {
    result.isPlayerIdAndZoneIdService = true
  } else if (config.playerId && config.server) {
    result.isPlayerIdAndServerService = true
  } else if (config.playerId) {
    result.isPlayerIdOnlyService = true
  } else if (config.uidPubg) {
    result.isPubgService = true
  }

  return result
}
